import { render } from "./index.vue?vue&type=template&id=2571a883&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2571a883&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2571a883"],['__file',"src/containers/widget/components/MonitoringStatusWidget/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2571a883"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2571a883', __exports__)) {
    api.reload('2571a883', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2571a883&scoped=true", () => {
    api.rerender('2571a883', render)
  })

}


export default __exports__